import { render, staticRenderFns } from "./edit.modal.vue?vue&type=template&id=46ff640f&scoped=true"
import script from "./edit.modal.vue?vue&type=script&lang=js"
export * from "./edit.modal.vue?vue&type=script&lang=js"
import style0 from "./edit.modal.vue?vue&type=style&index=0&id=46ff640f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ff640f",
  null
  
)

export default component.exports